<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import inputArgsService from '@/services/embeds/plugin/input.args.service'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'

const ideStore = useIdeStore()
const embedConfigStore = useEmbedConfigureStore()

const { getOnEditMode } = storeToRefs(embedConfigStore)
const { getInputArgsHideTitle, getInputArgsTitleName, getInputArgsDisplay, getInputArgsLines } =
  storeToRefs(ideStore)

onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  if (getOnEditMode.value === false) {
    inputArgsService.initInputArgus()
    inputArgsService.onSettingChange()
  }
})
onBeforeUnmount(async () => {
  if (getOnEditMode.value === false) {
    inputArgsService.destroyInputArgus()
  }
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div
    :class="[
      'flex h-full w-full gap-2 ',
      {
        'flex-col': !getInputArgsDisplay
      },
      {
        'flex-row items-center': getInputArgsDisplay
      }
    ]"
  >
    <label v-if="getInputArgsHideTitle" class="min-w-fit font-semibold leading-6">
      {{ getInputArgsTitleName }}</label
    >
    <textarea
      class="block w-full resize-none rounded-md border border-gray-400 p-2 outline-none"
      v-model="ideStore.inputArgs"
      :rows="getInputArgsLines"
    />
  </div>
</template>
